import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import funcoes from "../../models/funcoes";
import "../../assets/css/NovaFuncao.css";

const NovaFuncao = ({ open, toggle, onChageFunction }) => {
  const [data, setData] = useState([]);

  const start = async () => {
    setData(await funcoes.list_all());
  };

  useEffect(() => {
    if (open) start();
  }, [open]);

  return (
    <div>
      <Modal isOpen={open} size="lg" toggle={toggle}>
        <ModalHeader toggle={toggle}>Funções</ModalHeader>
        <ModalBody>
          <ListGroup className="list-group">
            {data.map((e) => (
              <ListGroupItem
                className="list-group-item"
                action
                onClick={() => onChageFunction({ ...e, code: null })}
              >
                <div className="item-container">
                  <img
                    src={e?.data?.type?.icon}
                    style={{ objectFit: "contain" }}
                    alt="icon"
                  />
                  <div className="item-text">
                    <span className="item-name">{e?.data?.title}</span>
                    <span className="item-detail">
                      {e?.data?.type.description}
                    </span>
                  </div>
                </div>
              </ListGroupItem>
            ))}
          </ListGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default NovaFuncao;
